import { memo } from "react";

import { QuestionCancelPolicy } from "@/components/features/items/edit/_shared/ui/components/main/questions/cancel-policy";

import { usePlanCancelPolicy } from "./hooks";

export const QuestionPlanCancelPolicy = memo(() => {
	const {
		cancelPolicy,
		useBaseCancelPolicy,
		toggleUseBaseCancelPolicy,
		append,
		removeCancelPolicyByIndex,
		beforeDaysOptions,
		updateBeforeDays,
		chargeRatioOptions,
		updateChargeRatio,
	} = usePlanCancelPolicy();

	const guide = `プラン独自のキャンセルポリシーが設定できます。<br />`;

	return (
		<QuestionCancelPolicy
			cancelPolicy={cancelPolicy}
			useBaseCancelPolicy={useBaseCancelPolicy}
			toggleUseBaseCancelPolicy={toggleUseBaseCancelPolicy}
			appendCancelPolicy={append}
			removeCancelPolicy={removeCancelPolicyByIndex}
			cancelPolicyBeforeDaysOptions={beforeDaysOptions}
			changeCancelPolicyBeforeDays={updateBeforeDays}
			cancelPolicyChargeRatioOptions={chargeRatioOptions}
			changeCancelPolicyChargeRatio={updateChargeRatio}
			hasError={cancelPolicy?.hasError}
			isEdited={cancelPolicy?.isEdited}
			guide={guide}
		/>
	);
});

QuestionPlanCancelPolicy.displayName = "QuestionPlanCancelPolicy";
